/**
 * Public marketing pages that are hidden until we're ready to launch them.
 *
 * Flipping a flag to `true` re-enables the page everywhere at once: the
 * header/footer links reappear and the gated route renders again. While a flag
 * is `false`, the corresponding route redirects to the landing page and its nav
 * links are hidden — the page components themselves are left untouched so
 * re-enabling is a one-line change.
 */
export const MARKETING_FLAGS = {
  /** Blog + articles (content in `components/marketing/blog-data.ts`). */
  blog: true,
  /** Careers page — hidden until we're actively hiring. */
  careers: false,
  /** Changelog — hidden until there is a real release history to show. */
  changelog: false,
  /**
   * Creator Partner Program (`/partners`, `/partners/terms`, `/partners/apply`).
   *
   * Live: the pages, the application form, the intake and the admin review and
   * provisioning flow. Prerendering and the sitemap follow this flag on their
   * own via `FLAGGED_PRERENDER_PATHS`; `public/robots.txt` and `public/llms.txt`
   * were updated by hand when it was turned on.
   */
  partners: true,
} as const;
